import { ConnectInstallation } from "@afar-research/contracts";
import { connectCall, connectKeyPair, type ConnectFetch } from "@afar-research/shared/connect";

/**
 * This device's identity within an AFAR Connect account.
 *
 * It authorizes nothing on an Environment — an Environment issues its own Environment Access
 * (ADR-0118). It names the device so the SSH Credential Vault can address a Wrapped SSH Credential
 * to it, and so the account can revoke that device.
 */
export interface ConnectInstallationCredential {
  installationId: string;
  credential: string;
  publicKey: string;
  privateKey: string;
}

export async function registerConnectInstallation(
  fetch: ConnectFetch,
  connectOrigin: string,
  accountToken: string,
): Promise<ConnectInstallationCredential> {
  const keys = await connectKeyPair();
  const installation = await connectCall(
    fetch,
    connectOrigin,
    "/v1/installations",
    accountToken,
    { publicKey: keys.publicKey },
    ConnectInstallation,
  );
  return { ...installation, ...keys };
}
